import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
    const [activeSection, setActiveSection] = useState('home');

    const scrollToSection = (e, sectionId) => {
        e.preventDefault();
        const element = document.getElementById(sectionId);
        if (element) {
            const headerOffset = 80;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const sections = ['home', 'about', 'customers', 'services', 'industries', 'why-us', 'contact'];
            const scrollPosition = window.scrollY + 100;

            for (const section of sections) {
                const element = document.getElementById(section);
                if (element) {
                    const { offsetTop, offsetHeight } = element;
                    if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
                        setActiveSection(section);
                        break;
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return ( <
        header className = "header" >
        <
        div className = "container header-container" >
        <
        div className = "logo" >
        <
        a href = "#home"
        onClick = {
            (e) => scrollToSection(e, 'home') } >
        <
        h1 > Dynamic Enterprises < /h1> <
        /a> <
        /div>

        <
        nav className = "nav" >
        <
        ul className = "nav-menu" >
        <
        li >
        <
        a href = "#home"
        onClick = {
            (e) => scrollToSection(e, 'home') }
        className = { activeSection === 'home' ? 'active' : '' } >
        Home <
        /a> <
        /li> <
        li >
        <
        a href = "#about"
        onClick = {
            (e) => scrollToSection(e, 'about') }
        className = { activeSection === 'about' ? 'active' : '' } >
        About <
        /a> <
        /li> <
        li >
        <
        a href = "#customers"
        onClick = {
            (e) => scrollToSection(e, 'customers') }
        className = { activeSection === 'customers' ? 'active' : '' } >
        Customers <
        /a> <
        /li> <
        li >
        <
        a href = "#services"
        onClick = {
            (e) => scrollToSection(e, 'services') }
        className = { activeSection === 'services' ? 'active' : '' } >
        Services <
        /a> <
        /li> <
        li >
        <
        a href = "#industries"
        onClick = {
            (e) => scrollToSection(e, 'industries') }
        className = { activeSection === 'industries' ? 'active' : '' } >
        Industries <
        /a> <
        /li> <
        li >
        <
        a href = "#why-us"
        onClick = {
            (e) => scrollToSection(e, 'why-us') }
        className = { activeSection === 'why-us' ? 'active' : '' } >
        Why Us <
        /a> <
        /li> <
        li >
        <
        a href = "#contact"
        onClick = {
            (e) => scrollToSection(e, 'contact') }
        className = { activeSection === 'contact' ? 'active' : '' } >
        Contact <
        /a> <
        /li> <
        li >
        <
        a href = "#contact"
        className = { `get-in-touch-btn ${activeSection === 'contact' ? 'active' : ''}` }
        onClick = {
            (e) => scrollToSection(e, 'contact') } >
        Get in Touch <
        /a> <
        /li> <
        /ul> <
        /nav> <
        /div> <
        /header>
    );
};

export default Header;